import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { businessDetailsSchema } from '../../model/schemas';

export function validateBusinessInfo(
  value: unknown,
  shouldSkipEmpty = true
): ValidationError[] {
  if (!value && shouldSkipEmpty) return [];
  const result = businessDetailsSchema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
